import { Effects } from "@react-three/drei"
import { extend } from "@react-three/fiber"
import { useContext } from "react"
import { UnrealBloomPass } from "three-stdlib"

import AppContext from "../hooks/AppConext"

extend({ UnrealBloomPass })

export const FX = () => {
  const { selected } = useContext(AppContext)
  const { i, radius } = {
    i: 0.28,
    radius: 1,
  }
  return selected ? null : (
    <Effects disableGamma>
      {/* threshhold has to be 1, so nothing at all gets bloom by default */}
      <unrealBloomPass threshold={1} strength={i} radius={radius} />
    </Effects>
  )
}
